import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=554772e1&scoped=true"
import script from "./app-header.vue?vue&type=script&lang=js"
export * from "./app-header.vue?vue&type=script&lang=js"
import style0 from "./app-header.vue?vue&type=style&index=0&id=554772e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554772e1",
  null
  
)

export default component.exports